"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseCartDto = exports.PurchaseResultDto = exports.ValidateParticipantDto = exports.PartialPaymentAsUserDto = exports.AddItemsDto = exports.RedeemPunchCardRequestDto = exports.PartialPaymentRequestDto = exports.ScheduledPaymentRequestBodyDto = exports.ScheduledPaymentRequestDto = exports.ScheduledPaymentConsumerRequestDto = exports.PurchaseProductDto = exports.PurchaseResourceDto = exports.PurchaseRequestDto = exports.ChargeRentalsReuqestDto = exports.PurchasePaymentDto = void 0;
const invoice_dto_1 = require("../../invoice/dto/invoice.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
class PurchasePaymentDto {
}
exports.PurchasePaymentDto = PurchasePaymentDto;
class ChargeRentalsReuqestDto {
}
exports.ChargeRentalsReuqestDto = ChargeRentalsReuqestDto;
class PurchaseRequestDto {
}
exports.PurchaseRequestDto = PurchaseRequestDto;
class PurchaseResourceDto {
}
exports.PurchaseResourceDto = PurchaseResourceDto;
class PurchaseProductDto {
}
exports.PurchaseProductDto = PurchaseProductDto;
class ScheduledPaymentConsumerRequestDto {
}
exports.ScheduledPaymentConsumerRequestDto = ScheduledPaymentConsumerRequestDto;
class ScheduledPaymentRequestDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ScheduledPaymentRequestDto = ScheduledPaymentRequestDto;
class ScheduledPaymentRequestBodyDto {
}
exports.ScheduledPaymentRequestBodyDto = ScheduledPaymentRequestBodyDto;
class PartialPaymentRequestDto {
}
exports.PartialPaymentRequestDto = PartialPaymentRequestDto;
class RedeemPunchCardRequestDto {
}
exports.RedeemPunchCardRequestDto = RedeemPunchCardRequestDto;
class AddItemsDto {
    constructor() {
        this.allocateResource = false;
        this.skipMail = false;
    }
}
exports.AddItemsDto = AddItemsDto;
class PartialPaymentAsUserDto {
}
exports.PartialPaymentAsUserDto = PartialPaymentAsUserDto;
class ValidateParticipantDto {
}
exports.ValidateParticipantDto = ValidateParticipantDto;
class PurchaseResultDto {
}
exports.PurchaseResultDto = PurchaseResultDto;
class PurchaseCartDto extends invoice_dto_1.InvoiceCartDto {
}
exports.PurchaseCartDto = PurchaseCartDto;
//# sourceMappingURL=purchase.dto.js.map